import { render } from "./fortuneCookie.vue?vue&type=template&id=f43c572e&scoped=true"
import script from "./fortuneCookie.vue?vue&type=script&lang=js"
export * from "./fortuneCookie.vue?vue&type=script&lang=js"

import "./fortuneCookie.vue?vue&type=style&index=0&id=f43c572e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f43c572e"]])

export default __exports__